
<ValidationObserver v-slot="{ invalid }" tag="section" class="container-fluid">
  <div class="row box">
    <div class="col-12">
      <h2>Create spotlight</h2>
      <form name="edit-module" role="form">
        <div class="row">
          <ValidationProvider v-slot="{ errors }" name="spotlight title" tag="div" class="col-5">
            <div class="form-group" :class="{'has-error': errors[0]}">
              <label for="title">Spotlight Title: *</label>
              <input id="title" v-model.trim="spotlightData.title" type="text" class="form-control" required="required">
              <small class="text-danger">{{ errors[0] }}</small>
            </div>
          </ValidationProvider>
          <div class="col-2">
            <div class="form-group">
              <label for="draft">draft-mode:</label><br>
              <input id="draft" v-model.lazy.trim="spotlightData.draft" type="checkbox" name="draft" value="1">
            </div>
          </div>
          <div v-if="spotlightData.sku" class="col-5">
            <div class="form-group">
              <label for="sku">SKU:</label>
              <input id="sku" v-model.lazy.trim="spotlightData.sku" type="text" class="form-control" name="sku" disabled="true">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="subline">Subline:</label>
              <froala-editor
                id="subline"
                v-model="spotlightData.subline"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <label for="author">Author / Footnote:</label>
              <input id="author" v-model.lazy.trim="spotlightData.author" type="text" class="form-control" name="author">
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label for="date">Date Information:</label>
              <input id="data" v-model.lazy.trim="spotlightData.date" type="text" class="form-control" name="date">
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label for="topics">Topics: </label>
              <input id="topics" v-model.lazy.trim="spotlightData.topics" type="text" class="form-control" name="topics" placeholde="topic 1,topic 2,third topic">
            </div>
          </div>
        </div>
      </form>
    </div>
    <hr>
    <SaveBar
      :saveDisabled="invalid"
      @save="createSpotlight(close = false)"
      @saveAndClose="createSpotlight(close = true)"
      @cancel="cancel"
    />
  </div>
</ValidationObserver>
